export enum SortByQueryParamValues {
  startedAt = 'started_at',
  duration = 'duration',
}

export enum SortDirectionQueryParamValues {
  ascending = 'ascending',
  descending = 'descending',
  none = 'none',
}

/**
 * Keeps a stale bookmarked URL (e.g. the removed `cache_hit`) from ordering the response by a column the UI no
 * longer offers, which would leave the visible sort state out of sync with the rows. Every reader of the sort
 * params has to go through this, or the request and the rendered sort control disagree.
 */
export const parseSortBy = (value: string | null): SortByQueryParamValues | null =>
  Object.values(SortByQueryParamValues).includes(value as SortByQueryParamValues)
    ? (value as SortByQueryParamValues)
    : null;
